var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouAreHereIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    color: "#db4439",
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7588 41.6302L38.7595 41.6295C43.5725 37.2734 46.5 30.923 46.5 24.3831C46.5 12.2837 36.6356 2.5 24.5 2.5C12.3644 2.5 2.5 12.2837 2.5 24.3831C2.5 28.4511 3.63281 32.4585 5.65183 35.9471L5.65255 35.9483C6.91227 38.122 8.55868 39.8226 10.0935 41.2997C10.4466 41.6396 10.7897 41.9642 11.123 42.2796C12.302 43.3951 13.3596 44.3958 14.3149 45.5528L14.3156 45.5536C16.6007 48.3187 18.451 51.506 20.3635 54.8004C20.4566 54.9606 20.5498 55.1212 20.6432 55.2819C22.3615 58.2394 26.6419 58.2394 28.3601 55.2819L28.3605 55.2812C28.9003 54.3516 29.3815 53.4662 29.8426 52.618C30.856 50.7537 31.7718 49.069 32.9959 47.4888C34.6071 45.4109 36.6378 43.5483 38.7588 41.6302Z",
    fill: "#db4439",
    stroke: "white",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 25.5,
    r: 7.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouAreHereIcon);
export default __webpack_public_path__ + "static/media/you-are-here-icon.989d377fa9bd173a5a2f1650971ad05e.svg";
export { ForwardRef as ReactComponent };